<template>
  <section id="access" class="hotelSection white">
    <div class="hotelSectionInner">
      <tk-hotel-map :latitude="latitude" :longitude="longitude"></tk-hotel-map>
      <h2 class="hotelH2">アクセス</h2>
      <tk-hotel-access-info
        :address="address"
        :train-access="trainAccess"
        :airport-access="airportAccess"
        :harbor-access="harborAccess"
        :highway-access="highwayAccess"
        :parking-info="parkingInfo"
        :pickup-service="pickupService"
      />
    </div>
  </section>
</template>

<script>
import TkHotelMap from '../TkHotelMap/TkHotelMap'
import TkHotelAccessInfo from './TkHotelAccessInfo'

export default {
  name: 'TkHotelAccess',
  components: { TkHotelMap, TkHotelAccessInfo },
  props: {
    latitude: {
      type: Number,
      required: true,
    },
    longitude: {
      type: Number,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    zoom: {
      type: Number,
      default: 13,
    },
    mapOptions: {
      type: Object,
      default: () => {},
    },
    trainAccess: {
      type: String,
      default: '',
    },
    airportAccess: {
      type: String,
      default: '',
    },
    harborAccess: {
      type: String,
      default: '',
    },
    highwayAccess: {
      type: String,
      default: '',
    },
    parkingInfo: {
      type: Object,
      default: () => {},
    },
    pickupService: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss">
@import '@ota-frontend/ui/src/scss/components/HotelCommon.scss';
@include media(sp) {
  .hotelSection {
    padding: 0 2% 40px;
  }
}
</style>
